export default "/images/1299843739011f93e7ce8598fac41d79.avif";